import React from 'react'
import { Platform, Pressable } from 'react-native'
import { useTranslation } from 'react-i18next'
import { router } from 'expo-router'

import TileBlur from '@ui/tiles/TileBlur'
import Button from '@ui/buttons/Button'
import useAnimatedPress from '@ui/animated/useAnimatedPress'

export default function CustomersSection() {
  const { animation, onPressIn, onPressOut } = useAnimatedPress()

  const { t } = useTranslation(['staff'])
  const text = 'staff:panel.sections.customers'

  const onPress = () => router.navigate('/staff/customers')

  return (
    <Pressable
      onPress={onPress}
      onPressIn={onPressIn}
      onPressOut={onPressOut}
      className="flex-1"
    >
      <TileBlur
        title={t(`${text}.title`)}
        desc={t(`${text}.desc`)}
        cta={
          <Button
            noninteractive
            animation={animation}
            onPress={onPress}
            size="sm"
            variant="outlined"
            label={t(`${text}.cta`)}
          />
        }
        glassProps={{
          animation,
          image: require('@/images/people.png'),
          imageWrapperStyle: {
            width: '125%',
            height: '125%',
          },
          imageStyle: {
            transform: [
              { translateX: Platform.select({ default: 0, web: -50 }) },
              { translateY: 25 },
            ],
          },
          blur: Platform.select({ default: 100, web: 25 }),
          blurStyle: {
            opacity: 0.8,
            transform: [
              { translateX: -75 },
              { translateY: 20 },
              { scale: 0.75 },
            ],
          },
        }}
      />
    </Pressable>
  )
}
